import { RatingTicketPhase } from '../../types/Rating/RatingTypes';

export const isPhaseScreenConfigured = (
  inServicePhases: RatingTicketPhase[] | undefined,
  ratingPhases: RatingTicketPhase[] | undefined,
  ticketPhase?: RatingTicketPhase | null,
): boolean => {
  if (!ticketPhase) {
    return false;
  }
  return (
    (inServicePhases?.includes(ticketPhase) ?? false) ||
    (ratingPhases?.includes(ticketPhase) ?? false)
  );
};
